import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateBasicConf() {
    return (
        <div data-cy="history-updateBasicConf">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateBasicConf" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWrench} style={{ color: 'orange' }} size="lg" />
            </Whisper>
        </div>
    );
}
